import * as auth from "redux/actions/auth";
import * as currentUser from "redux/actions/currentUser";
import * as theme from "redux/actions/theme";
import * as users from "redux/actions/users";
import * as cUsers from "redux/actions/cUsers";
import * as accounts from "redux/actions/accounts";
import * as statistics from "redux/actions/statistics";
import * as challenges from "redux/actions/challenges";
import * as fundedAccounts from "redux/actions/fundedAccounts";
import * as dashboard from "redux/actions/dashboard";
import * as rules from "redux/actions/rules";
import * as iaccounts from "redux/actions/investors";
import * as portfolio from "redux/actions/portfolio";

export default {
  auth,
  currentUser,
  theme,
  users,
  accounts,
  statistics,
  challenges,
  fundedAccounts,
  dashboard,
  rules,
  iaccounts,
  portfolio,
  cUsers,
};
